<div class="overLayDiv active"></div>
<div id="rightSideBar">
  <div class="rightSidePanel w-55pc d-flex flex-column">
    <header class="panel-header">
      <div class="viewDemo title-and-video">
        <h2>{{ panelHeader }}</h2>
        <app-video-icon [VideoUrl]="videoLink | safeUrl"></app-video-icon>
      </div>
      <div class="panel-left-btn">
        <button type="button" class="btn eod-btn-outline-warning height-38px mr-2" (click)="fnShowConfigureshowLoggingAlertPanel()">
          {{ "label_log" | translate }}
        </button>
        <button type="button" id="btn-save-tax-setup-guide" class="btn eod-btn-primary height-38px mr-2" [ngClass]="{'disabled':!hasFormChanges}" (click)="Save()">
          {{ "label_save" | translate }}
        </button>
        <button type="button" class="btn eod-btn-outline-warning height-38px" (click)="fnBacktoWizard()">
          {{ closeBtnText }}
        </button>
      </div>
    </header>
    <div class="block mt-2">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h6 class="fw-700">{{ 'receipt_type_text1' | translate: param }}</h6>
          <p *ngIf="originalTaxRateState">{{ 'receipt_type_text12' | translate: param }}</p>
          <p *ngIf="!originalTaxRateState">{{ 'self_setup_16_msg_24' | translate: param }}</p>
        </div>
        <div class="d-flex" id="turn-on-off-tax-setup-guide">
          <input type="checkbox" switch="bool" (change)="fnSetVATtype(!setNoVAT,true)"
            id="customSwitchRule3" [checked]="setNoVAT">
          <label class="m-0" for="customSwitchRule3"></label>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="overLayDiv" [ngClass]="{ 'active': showTurnOffConfirmation }"></div>
<div id="rightSideBar" [hidden]="!showTurnOffConfirmation">
    <div class="rightSidePanel d-flex flex-column">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{ 'label_confirm' | translate }}</h2>
            </div>
        </header>
        <div class="eod-panel-body-with-footer">
            <div class="block mt-2">
              <h6 class="info-text">
                <i class="fas fa-exclamation-circle eod-text-danger"></i>
                 <span *ngIf="claims.isManualVatOn">
                  {{ 'self_setup_16_msg_23' | translate }}
                </span>
                <span *ngIf="!claims.isManualVatOn">
                  {{ 'receipt_type_text12' | translate }}
                </span>
              </h6>
               
            </div>
        </div>
        <footer class="mt-auto py-1 d-flex justify-content-center align-items-center gap-2 height-60px">
            <button type="button" class="btn eod-btn-outline-warning" (click)="alertPanelReceiver(false)">
                {{ 'label_cancel' | translate }}
            </button>
            <button type="button" class="btn eod-btn-primary" (click)="alertPanelReceiver(true)">
                {{ 'label_confirm' | translate }}
            </button>
        </footer>
    </div>
</div>